import React from 'react';

export enum AEyebrowVariant {
  Primary = 'primary',
  Secondary = 'secondary',
}

export interface AEyebrowProps extends React.HTMLAttributes<HTMLElement> {
  children: React.ReactNode;
  variant?: AEyebrowVariant;
}
